// TODO: These should be API calls

/**
```
  // src/InSided/Doctrine/Entity/Forum.php
  TYPE_DEFAULT                  = 0;
  TYPE_KNOWLEDGE_BASE           = 1;
  TYPE_IDEATION                 = 2;
  TYPE_NEWS                     = 3;
```
*/
export enum LegacyCategoryType {
  default = 0,
  knowledgeBase = 1,
  ideation = 2,
  news = 3
}
